import { render, staticRenderFns } from "./ProfileSkillsView.vue?vue&type=template&id=22200419"
import script from "./ProfileSkillsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSkillsView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports